import { autoinject, LogManager, bindable } from 'aurelia-framework';
import { HelpTopicRepository } from 'data/repository/help-topic-repository';
import { HelpTopicPreferenceRepository } from 'data/repository/help-topic-preference-repository';
import { HelpTopic, HelpTopicPreference } from 'data/entities/entities';
import { EntityManager } from 'aurelia-orm';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { AppUserInfoService } from 'data/service/app-user-info-service';

@autoinject
export class HelpWidget {

	helpTopicRepository: HelpTopicRepository;
	//helpTopicPreferenceRepository: HelpTopicPreferenceRepository;
	eventSubscriptions: Subscription[] = [];

	constructor(
		private appUserInfoService: AppUserInfoService,
		entityManager: EntityManager,
		private eventAggregator: EventAggregator) {
		this.helpTopicRepository = entityManager.getRepository(HelpTopic);
		//this.helpTopicPreferenceRepository = entityManager.getRepository(HelpTopicPreference);
	}
	@bindable helpId: number;

	allowEdit = false;

	isEditing = false;

	edit() {
		this.newHelpItem.content = this.helpItem.content;
		this.isEditing = true;
	}

	newHelpItem = { content: ''};

	cancelEdit() {
		this.isEditing = false;
		this.newHelpItem.content = '';
	}

	saveEdit() {
		this.isEditing = false;
		this.helpItem.content = this.newHelpItem.content;
		this.helpItem.save();
	}

	helpItem: any = {};

	logger = LogManager.getLogger("HelpWidget");

	hideHelpSetting: boolean;

	hide() {
		this.helpItem.show = false;
		//this.savePreference();
	}

	async attached() {
		
		this.subscribeToEvents();
		this.hideHelpSetting = await this.appUserInfoService.getHideHelpSetting();
		this.logger.info("Current hideHelp setting is " + this.hideHelpSetting);
		this.getContent();
	}
    getCurrentAppUser(): any {
        throw new Error("Method not implemented.");
    }

	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	detached() {
		this.unsubscribeFromEvents();
	}

    subscribeToEvents(): any {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ShowHelpItem, id => {
			this.hideOrShowHelpItem(id);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.HideHelpSettingChanged, (hideHelpSetting:boolean) => {
			this.hideHelpSetting = hideHelpSetting;
			if (!this.hideHelpSetting) {
				this.getContent();
			}
			else {
				if (this.helpItem) {
					this.helpItem.show = false;
				}
			}
		}));
    }

	private hideOrShowHelpItem(id: any) {
        this.logger.info("Recieved event for ShowHelpItem");
		if (id == this.helpId) {
			this.helpItem.show = !this.helpItem.show;
			//this.savePreference();
        }
    }
  //  savePreference() {
		//this.helpTopicPreferenceRepository.updatePreference(this.helpId, this.helpItem.show)
  //  }

	async getContent() {
		if (this.hideHelpSetting) return;
		this.logger.info("Getting Help for id: " + this.helpId);
		try {
			this.helpItem = await this.helpTopicRepository.findOne(this.helpId);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

}